/**
 * Module for linking blue behavior into gazelle.
 */
import runSetBluePage from './set-blue-page.run';

export default angular.module('gazelle.core.blue', [
  'ngMaterial'
])
  .config(disableMaterialClickHijacking)
  .run(runSetBluePage)
  .name;

function disableMaterialClickHijacking($mdGestureProvider) {
  'ngInject';

  $mdGestureProvider.skipClickHijack();
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/blue/blue.module.js